/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Least_Legal_Jellyfish_PeelInputs */

const fr_least_legal_jellyfish_peel = /** @type {(inputs: Least_Legal_Jellyfish_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications sont bloquées sur ce navigateur. Cela peut être du a un refus ou alors a cause du navigateur.`)
};

/**

* @param {Least_Legal_Jellyfish_PeelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const least_legal_jellyfish_peel = /** @type {((inputs?: Least_Legal_Jellyfish_PeelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Least_Legal_Jellyfish_PeelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_least_legal_jellyfish_peel(inputs)
});